module.exports = __webpack_public_path__ + "static/media/bell.6082b12b.svg";